<template>
  <div class="popup form-popup visible" id="new-terminal-types-popup">
    <div class="popup-box">
      <p class="h2 title line">{{popupData.type === 'edit' ? 'Edit' : 'Add New' }} {{popupData.title}}</p>
      <form action="#" class="form">
        <div class="field" :class="v$.name.$error ? 'error-field' : ''">
          <label class="field-name">Name</label>
          <input type="text" class="form-control" :placeholder="popupData.title" v-model="name">
          <span class="error-text" v-if="v$.name.$error">Field required</span>
        </div>
        <div class="field" :class="v$.ref.$error ? 'error-field' : ''">
          <label class="field-name">Ref</label>
          <input type="email" class="form-control" placeholder="Ref" v-model="ref">
          <span class="error-text" v-if="v$.ref.$error">Field required</span>
        </div>
        <div class="form-btn-box">
                                    <span class="btn success no-bg small" @click="closePopup">
                                        <icon-base width="20" height="21" viewBox="0 0 20 21"><icon-deny/></icon-base>
                                        <span>Cancel</span>
                                    </span>
          <button type="button" class="btn success small" @click.prevent="actionClick">
            <icon-base width="20" height="21" viewBox="0 0 28 29"><icon-success/></icon-base>
            <span>{{popupData.type === 'edit' ? 'Edit' : 'Add'}}</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>

import {mapMutations, mapActions, mapState} from "vuex"
import IconBase from "../../common/IconBase";
import IconDeny from "../../common/icons/IconDeny";
import IconSuccess from "../../common/icons/IconSuccess";
import { useVuelidate } from "@vuelidate/core";
import { required } from "@vuelidate/validators";

export default {
    name: 'lx-settings-form',

    setup () {
        return { v$: useVuelidate() }
    },
    data () {
        return {
            name: '',
            ref: ''
        }
    },
    validations() {
        return {
            name: {required},
            ref: {required}
        }
    },
    components: {IconSuccess, IconDeny, IconBase},

    computed: {
        ...mapState({
            popupData: state => state.popupData,
        }),
    },

    mounted() {
        if (this.popupData.type === 'edit') {
            this.name = this.popupData.item.name;
            this.ref = this.popupData.item.ref;
        }
    },

    methods: {
        ...mapMutations([
            'switchPopup',
            'setPopupComponent'
        ]),
        ...mapActions('settings', [
            'getLXSettings',
            'addType',
            'updateType',
        ]),
        closePopup() {
            this.switchPopup(false);
        },
        actionClick() {
            this.v$.$touch();

            if (this.v$.$error) {
                return false;
            }

            let params = {};
            if (this.popupData.type === 'add') {
                params = {name: this.name, ref: this.ref};
            } else {
                params = {id: this.popupData.id, name: this.name, ref: this.ref};
            }

            this.popupData.func(params).then(() => {
                this.switchPopup(false);
                this.getLXSettings();
            });


        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
